
import { Link } from "react-router-dom"
import { LineWithText } from "components/FormGerarGuia"
import { userData, userLogado } from "services/LoginFunctions"
import * as Links from "constants/links"
import { useNavigate } from "react-router-dom"

import { translatePermissoes } from "services/MinhaConta/MinhaConta"
import stdStyle from "json/StdStyles.json"

const DadoPessoal = ({ label, info }) =>
{
    return (
        <div className="d-flex">
            <p className="fw-bold m-1">{label}:</p>
            <p className="mt-1">{info}</p>
        </div>
    )
}

export function MinhaContaScreen()
{
    const navigate = useNavigate()
    
    if (!userLogado)
    {
        navigate(Links.SEM_PERMISSAO)
    }

    const linkEstilo = "btn btn-primary rounded-5 mx-2 my-3 shadow border border-primary"

    return (
        <div className={stdStyle.taxForm}>
            <div className = "d-flex flex-column">
                <p className="fw-bold mt-3 mb-0 align-self-center">Dados da conta</p>
                <LineWithText />
                <DadoPessoal label={"Nome"} info={userData().nome} />
                <DadoPessoal label={"Matrícula"} info={userData().matricula} />
                <DadoPessoal label={"Função"} info={userData().cargo} />
                <DadoPessoal label={"Permissões"} info={translatePermissoes(userData().permissoes)} />
                <Link className={linkEstilo} to={Links.ALTERAR_SENHA}>Alterar senha</Link>
            </div>
        </div>
    )
}